import { FC } from 'react'
import { TextField, Typography, Button, Modal } from '@mui/material'
import { WalletCardModalProps } from './WalletCardModal.types'
import { useWalletCardModal } from './WalletCardModal.logic'
import styles from './WalletCardModal.module.scss'

const WalletCardModal: FC<WalletCardModalProps> = (props) => {
  const { open, onClose } = props
  const {
    formData,
    errors,
    isSubmitting,
    surgeryLoading,
    handleChange,
    handleSubmit,
  } = useWalletCardModal(props)

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={styles.walletCardModal}
      aria-labelledby="wallet-card-modal-title"
      aria-describedby="wallet-card-modal-description"
    >
      <div className={styles.modalContent}>
        <Typography
          id="wallet-card-modal-title"
          variant="h3"
          className={styles.modalTitle}
        >
          Send Wallet Card
        </Typography>

        <Typography
          id="wallet-card-modal-description"
          variant="body1"
          className={styles.modalDescription}
        >
          Enter patient information to send a wallet card
        </Typography>

        <div className={styles.formContainer}>
          <div className={styles.nameFieldsRow}>
            <TextField
              label="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.firstName}
              helperText={errors.firstName}
              disabled={isSubmitting}
              placeholder="First name"
              InputLabelProps={{ shrink: true }}
              className={styles.textField}
            />
            <TextField
              label="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.lastName}
              helperText={errors.lastName}
              disabled={isSubmitting}
              placeholder="Last name"
              InputLabelProps={{ shrink: true }}
              className={styles.textField}
            />
          </div>

          <TextField
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            error={!!errors.email}
            helperText={errors.email}
            disabled={isSubmitting}
            placeholder="Patient's email address"
            InputLabelProps={{ shrink: true }}
            className={styles.textField}
          />

          <TextField
            label="Phone Number"
            name="phoneNumber"
            type="tel"
            value={formData.phoneNumber}
            onChange={handleChange}
            fullWidth
            placeholder="(XXX) XXX-XXXX"
            error={!!errors.phoneNumber}
            helperText={
              errors.phoneNumber ||
              (formData.phoneNumber &&
              formData.phoneNumber.length > 0 &&
              formData.phoneNumber.length < 14
                ? 'Complete phone number required'
                : '')
            }
            disabled={isSubmitting}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              pattern: '\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}',
              title: 'Phone number format: (XXX) XXX-XXXX',
            }}
            className={styles.textField}
          />
        </div>

        <div className={styles.actionButtons}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isSubmitting}
            className={styles.button}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={isSubmitting || surgeryLoading}
            color="primary"
            className={styles.button}
          >
            {isSubmitting ? 'Sending...' : 'Send'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default WalletCardModal
